import { combineReducers } from "redux";
import { configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import authReducer from "./slices/authSlice";
import notificationSlice from "./slices/notificationSlice";
import tenantSlice from "./slices/tenantSlice";
import commonSlice from "./slices/commonSlice";
import tenantUserSlice from "./slices/tenantUserSlice";
import deviceSlice from "./slices/deviceSlice";
import locationSlice from "./slices/locationSlice";
import rolePermissionSlice from "./slices/rolePermissionSlice";
import calibrationSlice from "./slices/calibrationSlice";
import eventMapSlice from "./slices/eventMapSlice";
import locationCsvUploadRespoSlice from "./slices/locationCsvUploadRespoSlice";
import substanceSlice from "./slices/substanceSlice";
import adminSlice from "./slices/adminSlice";
import chartState from "./slices/grafanaChartsSlice";
import categorySubstanceSlice from "./slices/categorySubstanceSlice";
import themeSlice from "./slices/themeSlice";
import opsDashboardSlice from "./slices/opsDashboardSlice";
import profileSlice from "./slices/profileSlice";
import thresholdNotificationSlice from "./slices/thresholdNotificationSlice";
import userNotificationSlice from "./slices/userNotificationSlice";
import internalIdsSlice from "./slices/inernalIdsSlice";
import dashboardDownloadSlice from "./slices/downloadDashboard";
import emailTemplateSlice from "./slices/emailTemplates";
import newGrafanaSlice from "./slices/newGrafanaSlice";
import deviceHistorySlice from "./slices/deviceHistorySlice";
import querySlice from "./slices/querySlice";
import dashboardSlice from "./slices/dashboardSlice";
import tenantReportSlice from "./slices/tenantReportSlice";
import IeqGptSlice from "./slices/IeqGptSlice";
import FakeNotificationSlice from "./slices/fakeNotificationSlice";
import timeTrackerSlice from "./slices/timeTrackerSlice";
import exportHistory from "./slices/exportHistory";
import userEventHistory from "./slices/userEventHistory";
import detection from "./slices/detectionSlice";
import mainDashboard from "./slices/mainDashboardSlice";
import thirdPartyDeviceSlice from "./slices/thirdPartyDeviceSlice"
import { deviceIntegration } from "./slices/deviceIntegrationSlice";


const rootReducer = combineReducers({
  authReducer,
  notificationSlice,
  tenantSlice,
  commonSlice,
  tenantUserSlice,
  deviceSlice,
  locationSlice,
  rolePermissionSlice,
  calibrationSlice,
  eventMapSlice,
  locationCsvUploadRespoSlice,
  substanceSlice,
  adminSlice,
  chartState,
  categorySubstanceSlice,
  themeSlice,
  opsDashboardSlice,
  profileSlice,
  thresholdNotificationSlice,
  userNotificationSlice,
  internalIdsSlice,
  dashboardDownloadSlice,
  emailTemplateSlice,
  newGrafanaSlice,
  deviceHistorySlice,
  querySlice,
  dashboardSlice,
  tenantReportSlice,
  IeqGptSlice,
  FakeNotificationSlice,
  timeTrackerSlice,
  exportHistory,
  userEventHistory,
  detection,
  mainDashboard,
  thirdPartyDeviceSlice,
  deviceIntegration,
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
